import globalSlice from './globalSlice';

export { default as globalOp } from './operations';

export default globalSlice;
